/**
 * Module dependencies.
 */

import map from 'lodash/map';
import times from 'lodash/times';

/**
 * Export `normalizeFilterValues`.
 */

export function normalizeFilterValues(min: number, max: number) {
  const totalNumbers = (max - min) / 0.1;

  return map(times(totalNumbers + 1), (_, index) => {
    return min + index * 0.1;
  }).join(',');
}
